module.exports = __webpack_public_path__ + "static/media/canari_logo_music.a7a4bca7.png";